import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import Logo from "../../components/header/Logo";
import NavMenu from "../../components/header/NavMenu";
import IconGroup from "../../components/header/IconGroup";
import MobileMenu from "../../components/header/MobileMenu";
import { connect } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { removeFromCart } from "../../redux/actions/cartActions";
import useToken from "../../hook/useToken";
import { logoutUser } from "../../redux/actions/userAction";
import { clearProducts } from "../../redux/actions/productsAction";

const HeaderOne = ({ layout, top, borderStyle, headerPaddingClass, getSortParams, userData, clearProducts, logoutUser, removeFromCart }) => {
  const [scroll, setScroll] = useState(0);
  const [headerTop, setHeaderTop] = useState(0);
  const { token, setToken } = useToken();
  const history = useHistory()
  const hLogOutUser = async e => {
    e.preventDefault();
    logoutUser();
    clearProducts();
    //sessionStorage.setItem("token", 0)
    //setToken(0);
    //window.location.reload();
    setToken(0)
    if (global.aziendaID == 2) window.open(process.env.PUBLIC_URL + "/login", "_self")
    else window.open(process.env.PUBLIC_URL + "/", "_self");
    //history.push("/")
    //setTimeout(() => history.push(process.env.PUBLIC_URL + "/shop-grid-full-width?name="+queryText ),10);
  }

  var informazioni = global.informazioni

  const useFocusMobile = () => {
    const htmlElRef = useRef(null)
    const setFocus = () => { htmlElRef.current && htmlElRef.current.focus() }
    return [htmlElRef, setFocus]
  }

  const [inputRefMobile, setInputFocusMobile] = useFocusMobile();

  const handleClick = e => {
    e.currentTarget.nextSibling.classList.toggle("active");
  };

  useEffect(() => {
    const header = document.querySelector(".sticky-bar");
    if (!header)
      setHeaderTop(header.offsetTop);
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScroll = () => {
    setScroll(window.scrollY);
  };

  const isLoggedUser = (((userData?.user?.user) && (userData?.user?.user?.IDCli || userData?.user?.user?.IDAge))) ? true : false;

  return (
    <header className={`header-area clearfix`} style={{ width: '100%', backgroundColor: informazioni.backgroudMenu }}>

      <div
        className={` ${headerPaddingClass ? headerPaddingClass : ""
          } sticky-bar header-res-padding clearfix ${scroll > headerTop ? "stick" : ""}`} style={{ top: (scroll > headerTop ? '0px' : '0px') }}>
        <div>
          <div className="row" style={{ height: '50px', backgroundColor: informazioni.backgroudMenu, width: '100%', marginLeft: '0px', marginRight: '0px' }}>

            <div className="col-xl-1 col-lg-1 col-md-3 col-2" style={{ zIndex: 5 }} >
              {/* header logo */}
              <Logo imageUrl={informazioni.logoUrl} logoClass="logo" />
            </div>

            {isLoggedUser &&
              <div className="d-none d-lg-block col-xl-1 col-lg-1 col-md-3 col-2" style={{ zIndex: 5 }}>
                {((userData.user.user) && (userData.user.user.IDCli || userData.user.user.IDAge)) &&
                  <div className="header-right-wrap">


                    <div className="same-style account-setting">

                      <button
                        className="account-setting-active"
                        onClick={e => handleClick(e)}
                        display={'flex flex-row'}
                        style={{ display: 'flex', marginTop: (scroll <= headerTop) ? '8px' : '-15px', width: '200px', paddingLeft: '20px' }}
                      >
                        <img style={{ height: 50, width: 50, borderRadius: 25 }}
                          src={userData.user.user.WebImage ?
                            userData.user.user.WebImage : "https://t3.ftcdn.net/jpg/03/46/83/96/360_F_346839683_6nAPzbhpSkIpb8pmAwufkC7c5eD7wYws.jpg"}></img>
                        <p style={{ marginLeft: '10px', position: "relative", top: "-5px", fontSize: "12px", textAlign: "left", color: "white", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }}>  Benvenuto,<br /> {userData.user.user.RagSoc}</p>
                      </button>

                      <div className="account-dropdown" style={{ width: "200px" }}>
                        <ul>
                          <li>
                            <Link to={process.env.PUBLIC_URL + "/my-account"}>Il Tuo Account</Link>
                          </li>
                          {!userData?.user?.user?.IDCli ? (
                            <li>
                              <Link to={process.env.PUBLIC_URL + "/scadenziario-clienti"}>
                                Scadenziario clienti
                              </Link>
                            </li>
                          ) : null}
                          {userData.user.user?.IDCli === 37548 && window['configPegaso'].utentiAbilitatiConfRitiro?.includes(localStorage.getItem("IDDetCliRef")) && <li>
                            <Link to={process.env.PUBLIC_URL + "/ritiri"}>Configurazione ritiri</Link>
                          </li>}
                          {userData?.user?.user?.IDCli &&
                            window["configPegaso"].untentiModificaBanners?.includes(
                              localStorage.getItem("IDDetCliRef")
                            ) && <li>
                              <Link to={process.env.PUBLIC_URL + "/personalizzaBanners"}>Personalizza banners</Link>
                            </li>}
                          {userData?.user?.user?.IDCli &&
                            window["configPegaso"].untentiModificaBanners?.includes(
                              localStorage.getItem("IDDetCliRef")
                            ) && <li>
                              <Link to={process.env.PUBLIC_URL + "/personalizzaHomepage"}>Personalizza homepage</Link>
                            </li>}
                          <li>
                            <Link onClick={e => hLogOutUser(e)}> Disconnetti </Link>
                          </li>
                        </ul>
                      </div>
                    </div>

                    {/*
                <div className="main-menu" style={{textAlign: "center"}}>
                  <Link to={process.env.PUBLIC_URL + "/my-account"}>
                      {userData.user.user.Nom}
                  </Link>
                    </div>    */}
                  </div>}
              </div>}


            <div className="col-xl-9 col-lg-9 d-none d-lg-block">
              {/* Nav menu */}
              <NavMenu strings={require("../../translations/italian.json")} />
            </div>


            <div className="col-xl-1 col-lg-1 col-md-6 col-10">
              {/* Icon group */}
              <IconGroup setInputFocusMobile={setInputFocusMobile} refSearch={inputRefMobile} getSortParams={getSortParams} isUser={((userData.user.user) && (userData.user.user.IDCli || userData.user.user.IDAge))} />
            </div>


          </div>

        </div>

        {/* mobile menu */}
        <MobileMenu />

        <MobileMenu inputRefMobile={inputRefMobile} />
        <div style={{ textAlign: "center", backgroundColor: "red", color: "white", display: "none" }}>
          IL MAGAZZINO SARÀ CHIUSO PER INVENTARIO DAL 2 GENNAIO AL 5 GENNAIO COMPRESI - GLI UFFICI SARANNO SEMPRE APERTI
          <br />
          LE SPEDIZIONI E I RITIRI IN SEDE RIPRENDERANNO REGOLARMENTE DAL GIORNO 08/01/2024
          <br />
          BUONE FESTE
          <br />
          LO STAFF DGA
        </div>
      </div>
    </header>
  );
};

HeaderOne.propTypes = {
  borderStyle: PropTypes.string,
  headerPaddingClass: PropTypes.string,
  layout: PropTypes.string,
  top: PropTypes.string,
  isOnLine: PropTypes.bool,
  userData: PropTypes.object
};

const mapStateToProps = state => {
  return {
    currency: state.currencyData,
    cartData: state.cartData instanceof String ? JSON.parse(state.cartData) : state.cartData,
    wishlistData: state.wishlistData,
    compareData: state.compareData,
    userData: state.userData,
    productData: state.productData
  };
}

const mapDispatchToProps = dispatch => {
  return {
    removeFromCart: (item, addToast) => {
      dispatch(removeFromCart(item, addToast));
    },
    logoutUser: () => { dispatch(logoutUser()); },
    clearProducts: () => { dispatch(clearProducts()); }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderOne);